module.exports = __webpack_public_path__ + "static/media/close-white.fea2f051.svg";